import React, {useContext, useEffect, useState} from "react";
import FormBuilder from "../../../class/tool/FormBuilder";
import WebPushService from "../../tools/pushService/WebPushService";
import BackofficeContext from "../../../context/BackofficeContext";

const AccountFormSheet = props => {
    const { object, values, errors, updated, handleChange, handleSave } = props;
    const { setEvent } = useContext(BackofficeContext);
    const [ edit, setEdit ] = useState("");
    const [ rows, setRows ] = useState([
        {
            label: "Nom",
            attribute: "lastname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun",
            readOnly: true,
            edit: false
        },
        {
            label: "Prénom",
            attribute: "firstname",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun",
            readOnly: true,
            edit: false
        },
        {
            label: "Email",
            attribute: "email",
            inputType: "text",
            returnType: "string",
            classnameLabel: "label",
            classnameInput: "",
            classnameNoInput: "",
            placeholder: "",
            emptyText: "Aucun",
            readOnly: true,
            edit: false
        }
    ]);
    const [ pwdForm, setPwdForm ] = useState(false);
    const [ subcsribed, setSubscribed ] = useState(null);

    const buildRow = row => {
        if (edit === row.attribute || ["color"].includes(row.inputType) || ["tag"].includes(row.inputType))
            return FormBuilder.buildInputByType(row, values, errors, change, reinitEdit);
        else
            return FormBuilder.buildNoInputByType(row, values, handleEdit);
    }
    const initSubscribed = () => {

    }
    const handleEdit = attribute => {
        setEdit(attribute);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const reinitEdit = () => {
        setEdit("");
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();

        handleSave();
    }
    const subscribePush = () => {
        WebPushService.initSubscribeWebPush();
    }
    const unsubscribePush = () => {
        WebPushService.unsubscribeWebPush();
    }

    useEffect(() => {
        initSubscribed();
    }, []);
    useEffect(() => {
        console.log("SUBSCRIBED", subcsribed);
    }, [subcsribed]);

    return (
        <div className="clearing">
            <form
                className={"form inOverbox"}
                onSubmit={ handleSubmit } >
                {
                    rows.map((row, index) => (
                        <div key={ index } className="clearing">
                            <label className={ row.classnameLabel }>{ row.label }</label>
                            {
                                buildRow(row)
                            }
                        </div>
                    ))
                }
                <div className={"inForm"}>
                    <p className={"button blue"} onClick={subscribePush}>Activer</p>
                    <p className={"button gray"} onClick={unsubscribePush}>Désactiver</p>
                    <p className={"text"}>{ (subcsribed ? "Désactiver pour ne plus recevoir" : "Activer pour recevoir") } les notifications push sur cet appareil</p>
                </div>
            </form>
        </div>
    )
}

export default AccountFormSheet;
